import { render, staticRenderFns } from "./PDFGenerator.vue?vue&type=template&id=a4ecade4&"
import script from "./PDFGenerator.vue?vue&type=script&lang=js&"
export * from "./PDFGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports